"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const result_1 = __importDefault(require("./result"));
class MapboxRequest {
    constructor(options) {
        this.baseUrl = "https://api.mapbox.com/geocoding/v5";
        this.autoCompleteEndpoint = "mapbox.places";
        this.permanentEndpoint = "mapbox.places-permanent";
        this.options = options;
    }
    autocomplete(term) {
        return __awaiter(this, void 0, void 0, function* () {
            this.convertOptionType();
            return yield this.makeRequest(this.autoCompleteEndpoint, term);
        });
    }
    permanent(term) {
        return __awaiter(this, void 0, void 0, function* () {
            this.convertOptionType(true);
            const [result] = yield this.makeRequest(this.permanentEndpoint, term);
            return result;
        });
    }
    makeRequest(endpoint, term) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams(Object.assign({ types: this.types }, this.options));
            const url = this.url(endpoint, term) + "?" + params.toString();
            const result = yield (0, cross_fetch_1.default)(url);
            const json = (yield result.json());
            return json.features.map((location) => new result_1.default(location));
        });
    }
    url(endpoint, term) {
        return `${this.baseUrl}/${endpoint}/${term}.json`;
    }
    convertOptionType(permanent = false) {
        const locationMapping = {
            address: "address,place,locality",
            city: "place,locality",
            state: "region,place,locality",
            country: "country",
            place: "place",
        };
        if (!this.options.types)
            return;
        if (permanent) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - There is funky conversion in original code, that is not type easily safe
            this.types = this.options.types === "city" ? "place" : this.options.types;
        }
        else {
            this.types = locationMapping[this.options.types];
        }
        delete this.options.types;
    }
}
exports.default = MapboxRequest;
